<template>
  <div id="wx-container"></div>
</template>

<script>
export default {
  components: {},
  props: {
    env: {
      type: String,
      default: 'login'
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.loadSDK()
  },
  methods: {
    loadSDK () {
      const script = document.createElement('script')
      script.src =
        'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
      script.onload = this.getCode
      document.body.appendChild(script)
    },
    getCode () {
      let redirectUri = encodeURIComponent(
        'http://fish.oceanfish.org.cn:8011/yzzy_web/#/wxLoading'
      ) //对当前页的URL进行转码
      let obj = new WxLogin({
        self_redirect: true, //值为true时，直接在二维码的弹窗中进行页面跳转及其余操作,
        id: 'wx-container', //需要承载二维码的容器id
        appid: 'wxa2bea841e52b2c6e',
        scope: 'snsapi_login', //网页授权，目前网页只有这一种方式，静默授权
        redirect_uri: redirectUri, //回调域名(地址前部分是项目域名，后部分loginSuccess是微信需要跳转的路径（vue中的路由名称）)
        state: Math.random(),
        style: 'white',
        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O21hcmdpbi10b3A6IDA7cGFkZGluZzogMTBweDtiYWNrZ3JvdW5kOiByZ2JhKDc5LDk0LDEwNCwwLjgpO2JvcmRlci1yYWRpdXM6IDEwcHg7Ym9yZGVyOiB1bnNldCB9Ci5pbXBvd2VyQm94IC53cnBfY29kZSBpbWdbc3JjKj0iZXhwaXJlZCJdeyBjdXJzb3I6IHBvaW50ZXI7fQogLndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgeyAgZGlzcGxheTpmbGV4O2p1c3RpZnktY29udGVudDogY2VudGVyO2FsaWduLWl0ZW1zOiBjZW50ZXIgIH0KLndlYl9xcmNvZGVfc3dpdGNoX3dycCB7ICBtYXJnaW4tdG9wOiAwIH0KLndlYl9xcmNvZGVfc3dpdGNoIHsgIGNvbG9yOiAjMjY4NmYzO2N1cnNvcjogcG9pbnRlcjsgfQouanNfcXVpY2tfbG9naW4geyAgcGFkZGluZzogMTBweDtiYWNrZ3JvdW5kOiByZ2JhKDc5LDk0LDEwNCwwLjgpO2JvcmRlci1yYWRpdXM6IDEwcHggfQ=='
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#wx-container {
  text-align: center;
  height: 300px;
  /deep/ iframe {
    height: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wxLoginComponents/WeixinLogin.vue